import React from 'react';
import { SidePanel } from 'design-system-web';
import { CreateServiceRequest } from 'domains/workOrder/serviceRequest/components/CreateServiceRequest/CreateServiceRequest';

type ServiceRequestSidePanelProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function ServiceRequestSidePanel({
  isOpen,
  onClose,
}: ServiceRequestSidePanelProps) {
  return (
    <SidePanel
      id="generate-service-request-panel"
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
      backdropEnabled
      zIndex={5}
    >
      <CreateServiceRequest closeSidePanel={onClose} />
    </SidePanel>
  );
}
